"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectForm = void 0;
const T = __importStar(require("@microsoft/fast-element"));
require("./template.html");
const client_1 = require("@rws-framework/client");
const backendImport_1 = require("@front/backendImport");
const component_1 = require("@front/components/site-menu/component");
const form_parts_1 = require("@front/components/form-parts");
//@ts-ignore                
let rwsTemplate = T.html `<template>
  <div class="container-fluid">
    <div class="project-form-page">
      <div class="row">
        <div class="col-lg-8 col-12 pb-lg-5">
          <div class="mb-2">
            <h1>${x => x.projectId ? 'project.form.title.edit'.t() : 'project.form.title.add'.t()}</h1>
            <div class="text-zero top-right-button-container">
              <button @click="${(x, c) => x.cancel(c.event)}" type="button"
                class="top-right-button mr-1 btn btn-primary btn-lg">${'project.form.back'.t()}</button>
            </div>
          </div>
          <div class="card card-body mb-5">
            <the-form :onSubmit="${(x, c) => x.sendForm.bind(x)}">
              <div class="form-group">
                <part-input 
                  required="true"
                  class="form-part" 
                  label="${'project.name'.t()}" 
                  :value="${x => x.form.name}"
                  name="name" 
                  placeholder="${'project.name.placeholder'.t()}"
                ></part-input>
              </div>
              <div class="form-group">
                <part-textarea 
                  class="form-part" 
                  label="${'project.description'.t()}"
                  :value="${x => x.form.description}" 
                  name="description" 
                  rows="3"
                  placeholder="${'project.description.placeholder'.t()}"
                ></part-textarea>
              </div>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <part-input 
                    class="form-part" 
                    label="${'project.color'.t()}"
                    :value="${x => x.form.color}" 
                    name="color" 
                    type="color"
                    placeholder="${'project.form.color.placeholder'.t()}"
                  ></part-input>
                </div>
                <div class="form-group col-md-6">
                  <label class="form-label">${'project.icon'.t()}</label>
                  <icon-picker 
                    placeholder="${'project.form.icon.placeholder'.t()}"
                    :value="${x => x.form.icon}"
                    @icon-changed="${(x, c) => x.handleIconChange(c.event)}"
                  ></icon-picker>                  
                </div>
              </div>
              <div class="form-group">
                <div class="form-check">
                  <part-checkbox
                    class="form-part"
                    label="${'project.isActive'.t()}"
                    :value="${x => x.form.isActive}"
                    name="isActive"
                  ></part-checkbox>
                </div>
              </div>
              <div class="form-group mt-4">
                <button @click="${(x, c) => x.sendSubmit(x, c)}" type="submit" class="btn btn-primary btn-lg mr-2"
                  ?disabled="${x => x.loading}">
                  <span ?hidden="${x => !x.loading}" class="spinner-border spinner-border-sm me-2"></span>
                  ${x => x.projectId ? 'common.update'.t() : 'common.create'.t()}
                </button>
              </div>
            </the-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>`;
const styles = null;
const shadowOptions = { "mode": "open" };
let ProjectForm = class ProjectForm extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.projectId = null;
        this.form = {
            name: '',
            description: '',
            color: '#007bff',
            icon: 'simple-icon-folder',
            isActive: true
        };
        this.sendSubmit = form_parts_1.FormComponent.sendSubmitEvent;
    }
    async connectedCallback() {
        super.connectedCallback();
        this.projectId = this.routeParams.id;
        // Load project data if editing
        if (this.projectId) {
            await this.loadProject();
        }
        form_parts_1.FormComponent.listenForValuesChange.bind(this)('form');
    }
    async loadProject() {
        try {
            this.loading = true;
            const response = await this.apiService.back.get('project.get', {
                routeParams: { id: this.projectId }
            });
            if (response.success && response.data) {
                const project = response.data;
                this.form = {
                    name: project.name,
                    description: project.description || '',
                    color: project.color || '#007bff',
                    icon: project.icon || 'simple-icon-folder',
                    isActive: project.isActive !== false
                };
            }
        }
        catch (error) {
            console.error('Failed to load project:', error);
        }
        finally {
            this.loading = false;
        }
    }
    async sendForm(event) {
        event.preventDefault();
        try {
            this.loading = true;
            let response;
            if (this.projectId) {
                // Update existing project
                response = await this.apiService.back.put('project.update', this.form, {
                    routeParams: { id: this.projectId }
                });
            }
            else {
                // Create new project
                response = await this.apiService.back.post('project.create', this.form);
            }
            if (response.success) {
                component_1.SiteMenu.goto.bind(this)('/ai/knowledge/projects');
            }
        }
        catch (error) {
            console.error('Failed to save project:', error);
        }
        finally {
            this.loading = false;
        }
    }
    handleIconChange(event) {
        const { value } = event.detail;
        this.form.icon = value || '';
    }
    cancel(event) {
        event.preventDefault();
        component_1.SiteMenu.goto.bind(this)('/ai/knowledge/projects');
    }
    get isEditing() {
        return !!this.projectId;
    }
    get pageTitle() {
        return this.isEditing ? 'project.edit'.t() : 'project.create'.t();
    }
};
exports.ProjectForm = ProjectForm;
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], ProjectForm.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], ProjectForm.prototype, "projectId", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_a = typeof backendImport_1.IProjectPayload !== "undefined" && backendImport_1.IProjectPayload) === "function" ? _a : Object)
], ProjectForm.prototype, "form", void 0);
exports.ProjectForm = ProjectForm = __decorate([
    (0, client_1.RWSView)('project-form', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], ProjectForm);
ProjectForm.defineComponent();
